import { defineComponent as _defineComponent } from 'vue'
import AuthActionButton from '@/_core/shared/ui/AuthActionButton/AuthActionButton.vue';

interface InputData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  referralSource: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupCredentialsForm',
  props: {
    inputData: null,
    errors: { default: () => ({}) },
    isEmailValid: { type: [Boolean, null], default: null },
    isLoading: { type: Boolean, default: false },
    isEmptyInput: { default: '' },
    activeInputName: { default: null },
    emailLabel: { default: 'Email' },
    showReferral: { type: Boolean, default: false },
    referralLabel: { default: 'How did you hear about us?' },
    submitText: { default: 'Create Account' },
    submitDisabled: { type: Boolean, default: false },
    formError: { default: '' }
  },
  emits: ["set-active-input", "field-input", "field-change", "clear-field", "toggle-password"],
  setup(__props: any) {





return { __sfc: true,AuthActionButton }
}

})